import React, {useEffect, useState} from 'react';
import {Accordion, AccordionSummary, Box, Button, Card, CardContent, Divider, Stack} from "@mui/material";
import {useParams} from "react-router-dom";
import {executeQueryUtil} from "../../../utils/gqlUtil";
import {getEstablishmentQuery} from "../../../gql/establishmentGql";
import useAuth from "../../../hooks/useAuth";
import AccordionActions from '@mui/material/AccordionActions';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CashPadIntegration from "./CashPadIntegration";
import localStrings from "../../../localStrings";
import EqualogIntegration from "./EqualogIntegration";

export const hubrise = "hubrise";
export const fullapps = "fullapps";
export const ladddition = "ladddition";
export const cashpad = "cashpad";

function Integration() {

    const {establishmentId} = useParams();
    const {currentBrand} = useAuth();
    const [integrationType, setIntegrationType] = useState( null)

    useEffect(() => {
            const loadEstablishment = async () => {
                var res =  await executeQueryUtil(getEstablishmentQuery(currentBrand().id, establishmentId));
                setIntegrationType(res.data?.getEstablishment?.integrationType);
            }
            loadEstablishment();

        },
        [])

    return (
        <>
        <Stack spacing={1}>
            <Divider/>
            <Typography variant="h6">
                {localStrings.posSystems}
            </Typography>
            <Card>
                <CardContent>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2-content"
                            id="panel2-header"
                        >
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'}}
                            >
                                <Box>
                                    <img height={25} src="/assets/integrationLogos/cashpad_logo.jpg"/>

                                </Box>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginLeft: 2
                                }}>
                                    <Typography variant='h6'>CashPad</Typography>

                                </Box>
                                <Box sx={{flexGrow: 1}}/>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <CashPadIntegration/>
                        </AccordionDetails>
                    </Accordion>
                </CardContent>
            </Card>
        </Stack>

            <Stack spacing={1}>
                <Divider/>
                <Typography variant="h6">
                    {localStrings.humanResoucesSystems}
                </Typography>
                <Card>
                    <CardContent>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between'}}
                                >
                                    <Box>
                                        <img height={25} src="/assets/integrationLogos/equalog_logo.jpg"/>

                                    </Box>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginLeft: 2
                                    }}>
                                        <Typography variant='h6'>Equalog</Typography>
                                    </Box>
                                    <Box sx={{flexGrow: 1}}/>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <EqualogIntegration/>
                            </AccordionDetails>
                        </Accordion>
                    </CardContent>
                </Card>
            </Stack>

        </>
    )
}

export default Integration